import { ReactComponent as Email } from "./Assets/svgs/email.svg";
import { ReactComponent as Linkedin } from "./Assets/svgs/linkedin.svg";
import { ReactComponent as X } from "./Assets/svgs/x.svg";
import { ReactComponent as Github } from "./Assets/svgs//github-footer.svg";
import { ReactComponent as Instagram } from "./Assets/svgs/instagram.svg";
import { ReactComponent as Youtube } from "./Assets/svgs/youtube.svg";
import { ReactComponent as Behance } from "./Assets/svgs/behance.svg";
import { ReactComponent as Dribble } from "./Assets/svgs/dribble.svg";

function Footer({ darkMode }) {
  const date = new Date().getFullYear();
  // console.log(date);
  return (
    <>
      <div className="h-fit w-full 100:px-6 md:px-16 py-24 flex-col justify-start items-center gap-12 inline-flex">
        <div className="footer flex-col justify-start items-center gap-2.5 inline-flex">
          <a href="mailto:obiijeoma32@gmail.com">
            <div className={`text-center hover:underline ${darkMode ? "text-[#5676ff] hover:text-[#ccd2d5]" : "text-[#0c0eff] hover:text-[#495055]"} text-base font-normal font-inter lowercase leading-relaxed`}>obiijeoma32@gmail.com</div>
          </a>
          <h1 className={`md:w-[630px] italic 100:w-full text-center solid-shadow ${darkMode ? "text-[#e4e7e9] solid-shadow-dark" : "text-[#ccd2d5] solid-shadow-light"} text-5xl font-normal  font-instruement`}>
            Let's Build Something Great Together
          </h1>

          <p className={`100:w-full md:w-[513px] text-center  ${darkMode ? "text-[#a9b2b7]" : "text-[#555f65]"} text-base font-normal font-inter capitalize leading-relaxed`}>
            Ready to collaborate or discuss a project? Reach out and let's create something amazing!
          </p>
        </div>
        <div className="w-full contact md:px-4 flex-col justify-start items-start gap-8 inline-flex">
          <div className={`w-full h-px bg-[#ccd2d5]`} />
          <div className=" w-full 100:gap-8 100:flex-col lg:flex-row justify-between 100:items-center lg:items-start inline-flex">
            <div className={`md:w-fit 100:w-full 100:flex-wrap ${darkMode ? "text-[#A9B2B7]" : "text-[#495055]"} 100:justify-center  sm:justify-start items-center gap-6 inline-flex`}>
              <a className={` ${darkMode ? " hover:text-[#5676FF]" : " hover:text-[#0c0eff]"}`} href="mailto:obiijeoma32@gmail.com">
                <Email />
              </a>
              <a className={` ${darkMode ? " hover:text-[#5676FF]" : " hover:text-[#0c0eff]"}`} href="https://www.linkedin.com/in/obiijeoma32/">
                <Linkedin />
              </a>
              <a className={` ${darkMode ? " hover:text-[#5676FF]" : " hover:text-[#0c0eff]"}`} href="https://x.com/mynameiscandy_/">
                <X />
              </a>
              <a className={` ${darkMode ? " hover:text-[#5676FF]" : " hover:text-[#0c0eff]"}`} href="https://github.com/Obiijeoma32/">
                <Github />
              </a>
              <a className={` ${darkMode ? " hover:text-[#5676FF]" : " hover:text-[#0c0eff]"}`} href="https://www.instagram.com/candydesignandcode">
                <Instagram />
              </a>
              <a className={` ${darkMode ? " hover:text-[#5676FF]" : " hover:text-[#0c0eff]"}`} href="https://www.youtube.com/@obiijeoma4291">
                <Youtube />
              </a>
              <a className={` ${darkMode ? " hover:text-[#5676FF]" : " hover:text-[#0c0eff]"}`} href="https://www.behance.net/ijeomaobi">
                <Behance />
              </a>
              <a className={` ${darkMode ? " hover:text-[#5676FF]" : " hover:text-[#0c0eff]"}`} href="https://dribbble.com/Candy-obi">
                <Dribble />
              </a>
            </div>
            <div className={`${darkMode ? "text-[#7e8b92]" : "text-[#637077]"} 100:text-center sm:text-left text-base font-normal font-inter leading-normal`}>© {date} CANDY. All rights reserved.</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
